import { Box, Typography, styled } from '@material-ui/core';
import { SRoundedContainer } from '@setvi/shared/components';

export const Container = styled(SRoundedContainer)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  flex: 1,
  padding: theme.spacing(2, 4),
  minHeight: 0
}));

export const MetadataMessage = styled(Box)({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'end'
});

export const ContentContainer = styled(Box)({
  background: '#F0F0F4',
  borderRadius: 12,
  padding: 12
});

export const QuestionTitle = styled(Typography)({
  fontSize: 20,
  fontWeight: 500,
  marginBottom: 8
});

export const EmptyContainer = styled(Box)({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gridGap: 12,
  borderRadius: 16,
  border: '1px solid #EEF0F2'
});
